<div class="main-container" >
    <div class="header-title" *ngIf="!isHome">
        <div class="left">
            <div class="back-icon">
                <img src="assets/navbar-component-images/fluent_ios-arrow-24-filled.svg" alt="" (click)="goBack()">
            </div>
            <div style="display: flex; position: relative; width: fit-content; height: fit-content;">
                <img src="assets/navbar-component-images/banner.svg" alt="banner.svg" >
                <img src="assets/navbar-component-images/bannerVector.svg" alt="bannerVector.svg" style="position: absolute; left: 35%; top: 17%;">
            </div>
            <div class="title">
                <h1>ศูนย์ปฏิบัติการค้นหาข่าวกรอง</h1>
            </div>
        </div>
    </div>
    <div class="gap" *ngIf="!isHome"></div>
    <app-search-box *ngIf="!isHome"
    [search_input]="input_text" 
    [width]="'50%'"
    [top]="'-20px'"
    [left]="'2%'"
    (onSearch)="onSearch($event)"
    (onAiSearch)="onAiSearch($event)"></app-search-box>

    <div class="spacer"></div>
    
    <!-- ai_box -->
    <div class="container">
    <app-ai_box class="bg-container"
    [class.hidden]="notFound" 
    [notFound]="notFound"></app-ai_box>
    </div>
    
    <div class="search-result-container">
        <div class="option-container">
            <p>ผลการค้นหา {{ resultsFound }} รายการ</p>
            <div class="button-container">
                <button class="list-button" [ngClass]="{'active': showList}" (click)="onListButtonClick()">
                    <img [src]="list_icon_deactive" alt="list_icon">
                </button>
                <button class="box-button" [ngClass]="{'active': !showList}" (click)="onBoxButtonClick()">
                    <img [src]="box_icon_deactive" alt="box_icon">
                </button>
            </div>
            <p>เรียงตาม</p>
            <select [(ngModel)]="select" (change)="onSelectChange()">
                <option>เกี่ยวข้อง</option>
                <option>จำนวนการดู</option>
                <option>เวลาที่อัพโหลด</option>
            </select>
        </div>
        <div *ngIf="notFound" class="not-found-message custom-not-found">
            <p>Not Found</p>
        </div>
        <app-list-results *ngIf="showList && !notFound"
        [results]="results"
        [loading]="loadingNews || !ready"
        [descriptionLines]="2"
        [showMapButton]="true"
        [imageHeight]="'200px'"
        [imageRatio]="16 / 9"
        [nameDateConnect]="true"
        [skeleton]="true"
        [reachTheEnd]="reachTheEnd"
        (onRequestMoreSearchResults)="getMoreNews()"
        (onResultClick)="onResultClick($event)"
        (onMapButtonClick)="goToMap($event)"></app-list-results>
        <app-box-results *ngIf="!showList"
        [results]="results"
        [loading]="loadingNews"
        [skeleton]="true"
        [reachTheEnd]="reachTheEnd"
        (onMapButtonClick)="goToMap($event)"
        (onResultClick)="onResultClick($event)"
        (onRequestMoreSearchResults)="getMoreNews()"></app-box-results>
        </div>
</div>
